import styled from "styled-components";

export const Button = styled.a`
  font-size: 1.6rem;
  text-align: center;
  color: ${(props) => (props.outline ? "#000E40" : props.theme.colors.white)};
  border: 1px solid #000E40;
  text-decoration: none;
  padding: 1.2rem 2.4rem;
  background-color: ${(props) => (props.outline ? props.theme.colors.white : props.theme.colors.secondary)};
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
`;
